import { ASSIGNED_REVIEW_TASK_TABS } from '../constants/assignedReviewTaskDomainConstants';

/** Maps UI tab to API req status. */
export function reqStatusFromTab(tab) {
  if (tab === ASSIGNED_REVIEW_TASK_TABS.APPROVED) return 'APPROVED';
  if (tab === ASSIGNED_REVIEW_TASK_TABS.REJECTED) return 'REJECTED';
  return 'IN-REVIEW';
}
